import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CRadioComponent } from './c-radio.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IsContainedInControlValuePipeModule } from 'src/app/pipes/is-contained-in-control-value-pipe/is-contained-in-control-value-pipe.module';

import { AsPipesModule } from '../../../pipes/as-pipes/as-pipes.module';

@NgModule({
  declarations: [CRadioComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    IsContainedInControlValuePipeModule,
    AsPipesModule,
  ],
  exports: [CRadioComponent]
})
export class CRadioModule { }
